import { Check } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const WhenWorksBest = () => {
  const { t } = useLanguage();
  return (
    <section className="relative py-20 md:py-28" data-testid="when-works-best-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-3xl border border-white/10 bg-[#111] p-8 md:p-14 overflow-hidden">
          <div className="absolute -left-24 -top-24 w-80 h-80 rounded-full bg-[#e10600]/10 blur-3xl pointer-events-none" />
          <div className="absolute -right-24 -bottom-24 w-80 h-80 rounded-full bg-white/[0.03] blur-3xl pointer-events-none" />

          <div className="relative grid md:grid-cols-5 gap-10 items-start">
            <div className="md:col-span-2">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 bg-white/5 text-[11px] tracking-[0.25em] uppercase font-display text-white/70">
                <span className="w-1.5 h-1.5 rounded-full bg-[#e10600]" />
                {t.when.eyebrow}
              </div>
              <h2 className="mt-4 font-display font-black text-3xl md:text-4xl tracking-tight">
                {t.when.title}
              </h2>
            </div>
            <div className="md:col-span-3">
              <p className="text-white/70 text-base md:text-lg leading-relaxed">
                {t.when.copy}
              </p>
              <div className="mt-6 flex flex-wrap gap-2.5">
                {t.when.chips.map((c, i) => (
                  <span
                    key={c}
                    className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full border border-[#e10600]/30 bg-[#e10600]/5 text-sm text-white/85 font-semibold"
                    data-testid={`when-chip-${i}`}
                  >
                    <Check className="w-3.5 h-3.5 text-[#e10600]" />
                    {c}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhenWorksBest;
